/* 🤖 this file was generated by svg-to-ts*/
export const iconGrid: {
  name: 'grid';
  data: string;
} = {
  name: 'grid',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 9a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-3a1 1 0 011-1zM6 9a1 1 0 011 1v3a1 1 0 01-1 1H3a1 1 0 01-1-1v-3a1 1 0 011-1zm6 2h-1v1h1zm-7 0H4v1h1zm1-9a1 1 0 011 1v3a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1zm7 0a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1V3a1 1 0 011-1zM5 4H4v1h1zm7 0h-1v1h1z"/></svg>`,
};
